import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d42cf872")

_pushScopeId("data-v-d42cf872")
const _hoisted_1 = { class: "display-condition mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between flex-1 overflow-hidden max-h-10"
}
const _hoisted_3 = { class: "list-condition" }
const _hoisted_4 = {
  class: "flex items-center text-sm flex-wrap",
  ref: "searchRequest"
}
const _hoisted_5 = { class: "mr-4 h-8 leading-8" }
const _hoisted_6 = {
  class: "flex items-center",
  style: {"min-width":"max-content"}
}
const _hoisted_7 = {
  key: 0,
  class: "text-gray-500 text-sm mr-8"
}
const _hoisted_8 = { class: "mr-2 text-sm text-blue-700 hover:opacity-75" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "text-lg font-bold mb-4" }
const _hoisted_11 = { class: "flex items-center justify-between" }
const _hoisted_12 = { class: "ml-1" }
const _hoisted_13 = { class: "flex items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ArrowDownBlueIcon = _resolveComponent("ArrowDownBlueIcon")
  const _component_CloseIcon = _resolveComponent("CloseIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!$setup.showSearchDetail)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "title", {}, () => [
                _createVNode("div", _hoisted_5, _toDisplayString($setup.t('displayConditions')), 1)
              ], {}, true),
              _renderSlot(_ctx.$slots, "compact", {}, undefined, true)
            ], 512)
          ]),
          _createVNode("div", _hoisted_6, [
            ($setup.heightRequestSearch > 42)
              ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString($setup.t('other')), 1))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "cursor-pointer flex items-center",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleSearchDetail && $setup.toggleSearchDetail(...args)))
            }, [
              _createVNode("span", _hoisted_8, _toDisplayString($setup.t('actionEdit')), 1),
              _createVNode("span", {
                class: $setup.showSearchDetail ? 'arrow-active' : ''
              }, [
                _createVNode(_component_ArrowDownBlueIcon)
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, _toDisplayString($setup.t('displayConditions')), 1),
      _renderSlot(_ctx.$slots, "form", {}, undefined, true),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          variant: "outline-primary",
          class: "w-28 close text-base outline-primary",
          onClick: $setup.closeSearchDetail
        }, {
          default: _withId(() => [
            _createVNode(_component_CloseIcon),
            _createVNode("span", _hoisted_12, _toDisplayString($setup.t('closeUp')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_Button, {
            variant: "outline-danger",
            class: "w-28 reset text-base",
            onClick: $setup.resetSearchConditions
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString($setup.t('resetMember')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: $setup.searchForm,
            class: "w-28 text-base ml-4"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString($setup.t('narrowDown')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 512), [
      [_vShow, $setup.showSearchDetail]
    ])
  ]))
})